/* EXAM BOARDS */
export const GET_EXAMBOARDS = "GET_EXAMBOARDS"
export const GET_EXAMBOARDS_SUCCESS = "GET_EXAMBOARDS_SUCCESS"
export const ADD_NEW_EXAM_BOARD = "ADD_NEW_EXAM_BOARD"
export const ADD_NEW_EXAM_BOARD_SUCCESS = "ADD_NEW_EXAM_BOARD_SUCCESS"
export const RESET_STORE_EXAM_BOARD = "RESET_STORE_EXAM_BOARD"
export const DELETE_EXAM_BOARD = "DELETE_EXAM_BOARD"
export const DELETE_EXAM_BOARD_SUCCESS = "DELETE_EXAM_BOARD_SUCCESS"

